function setCookie(name: string, data: any, days: number) {
	if (typeof data === "object") data = JSON.stringify(data);
	let expires = "";
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (data || "") + expires + "; path=/";
}

function getCookie(name: string) {
	if (document && document?.cookie) {
		const value = `; ${document?.cookie}`;
		const parts = value.split(`; ${name}=`);
		// @ts-ignore
		if (parts.length === 2) return parts.pop().split(";").shift();
	}
}

function removeCookie(name: string) {
	const date = new Date();
	date.setTime(date.getTime() + (-5 || 7) * 24 * 60 * 60 * 1000);
	const expires = date.toUTCString();
	document.cookie = `${name}='';samesite=None;secure=true expires=${expires}; path=/`;
	// eslint-disable-next-line prefer-const
	let parts = location.hostname.split(".");
	// eslint-disable-next-line prefer-const, @typescript-eslint/no-unused-vars, no-unused-vars
	let subdomain = parts.shift();
	// eslint-disable-next-line prefer-const
	let upperleveldomain = parts.join(".");
	document.cookie = `${name}='';domain=${upperleveldomain}; expires=${expires}; path=/`;
}

function removeWildCardCookie(name: string) {
	const date = new Date();
	date.setTime(date.getTime() + (-5 || 7) * 24 * 60 * 60 * 1000);
	const expires = date.toUTCString();
	const parts = location.hostname.split(".");
	parts.shift();
	const upperleveldomain = parts.join(".");
	document.cookie = `${name}='';domain=${upperleveldomain}; expires=${expires}; path=/`;
}

function setWildCardCookie(name: string, data: any, days: number) {
	if (typeof data === "object") data = JSON.stringify(data);
	let expires = "";
	// eslint-disable-next-line prefer-const
	let parts = location.hostname.split(".");
	// eslint-disable-next-line prefer-const, @typescript-eslint/no-unused-vars, no-unused-vars
	let subdomain = parts.shift();
	// eslint-disable-next-line prefer-const
	let upperleveldomain = parts.join(".");
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = ";expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (data || "") + expires + ";domain=" + upperleveldomain + ";path=/";
}

export { setWildCardCookie, removeWildCardCookie, removeCookie, setCookie, getCookie };
